


































import Vue from 'vue';

export default Vue.extend({
  data: () => ({
    openDialog: false,
    nuevaSerie: {
      nombre: '',
      ultimoFolioGenerado: 0,
      creationDateTime: '',
      creationUsername: '',
    },
    loading: false,
  }),
  methods: {
    modeloSerie() {
      return {
        nombre: '',
        ultimoFolioGenerado: 0,
        creationDateTime: '',
        creationUsername: '',
      };
    },
    async AgregarSerie() {
      this.nuevaSerie.creationUsername = this.$store.getters.getUsername;
      this.nuevaSerie.creationDateTime = this.$moment().format();
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const serie = this.nuevaSerie;
        const result = await this.$store.dispatch('addSerie', {admin, condo , serie} );
        console.debug('Respuesta addSerie: %o', result);
        this.$toast.success('Serie agregada');
      } catch (e) {
        console.error(e);
        this.$toast.error(e.response.data.message);
      }
      this.loading = false;
      this.openDialog = false;
      this.$emit('reload', {});
    },
    restrictChars($event) {
      if (/[0-9]/.test(String.fromCharCode($event.charCode))) {
        return true;
      } else {
          $event.preventDefault();
      }
    },
  },
  watch: {
    openDialog() {
      if (!this.openDialog) {
        this.nuevaSerie = this.modeloSerie();
      }
    },
  },
});
